// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bCcDW","top":"styles_top__3zLlh","left":"styles_left__4PZ29","description":"styles_description__2FrK2"};